import React from 'react';
import { Admin, Resource } from 'react-admin';
import { authProvider, dataProvider as createDataProvider } from '../../providers';
import SignInPageWrapper from '../login/sign-in-page-wrapper';
import Dashboard from '../../components/dashboard';
import {
  List as ArtistsList,
  Edit as ArtistsEdit,
  Create as ArtistsCreate,
} from '../../components/artists';
import {
  List as ProductsList,
  Edit as ProductsEdit,
  Create as ProductsCreate,
} from '../../components/products';
import {
  List as CategoriesList,
  Edit as CategoriesEdit,
  Create as CategoriesCreate,
} from '../../components/category';
import {
  List as HostsList,
  Edit as HostsEdit,
  Create as HostsCreate,
} from '../../components/hosts';
import {
  List as ProvidersList,
  Edit as ProvidersEdit,
} from '../../components/providers';
import {
  List as ReportList,
} from '../../components/report';
import customRoutes from '../../routes';
import Layout from '../../components/layout';
import './index.css';
import { createTheme } from '@material-ui/core/styles';

const { REACT_APP_BACKEND_URL } = process.env;

const dataProvider = createDataProvider(REACT_APP_BACKEND_URL);

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#538181',
      contrastText: '#fff',
    },
    secondary: {
      main: '#6FAFB0',
      contrastText: '#fff',
    },
    text: {
      primary: '#538181',
      secondary: 'rgb(27, 40, 40)',
    },
  },
  shape: {
    borderRadius: 16,
  },
});

const App = () => (
  <Admin
    loginPage={SignInPageWrapper}
    theme={theme}
    customRoutes={customRoutes}
    dashboard={Dashboard}
    authProvider={authProvider}
    dataProvider={dataProvider}
    layout={Layout}
  >
    {(permissions) => [
      <Resource
        name="artists"
        options={{ label: 'Artists' }}
        create={ArtistsCreate}
        list={ArtistsList}
        edit={ArtistsEdit}
      />,
      <Resource
        name="products"
        options={{ label: 'Artworks' }}
        list={ProductsList}
        edit={ProductsEdit}
        create={ProductsCreate}
      />,
      <Resource
        name="categories"
        options={{ label: 'Categories' }}
        list={CategoriesList}
        edit={CategoriesEdit}
        create={CategoriesCreate}
      />,
      <Resource
        name="hosts"
        options={{ label: 'Hosts' }}
        list={HostsList}
        edit={HostsEdit}
        create={HostsCreate}
      />,
      <Resource
        name="users"
        options={{ label: 'Users' }}
        list={null}
        edit={null}
        create={null}
        show={null}
      />,
      <Resource
        name="art-types"
        options={{ label: 'Art Types' }}
        list={null}
        edit={null}
        create={null}
        show={null}
      />,
      <Resource
        name="places"
        options={{ label: 'Places' }}
        list={null}
        edit={null}
        create={null}
        show={null}
      />,
      <Resource
        name="providers"
        options={{ label: 'Providers' }}
        list={ProvidersList}
        edit={ProvidersEdit}
      />,
      <Resource
        name="report"
        options={{ label: 'Report' }}
        list={ReportList}
      />
    ]}
  </Admin>
);

export default App;
